/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbFacilitySummary } from './HchbFacilitySummary';
import {
    HchbFacilitySummaryFromJSON,
    HchbFacilitySummaryFromJSONTyped,
    HchbFacilitySummaryToJSON,
    HchbFacilitySummaryToJSONTyped,
} from './HchbFacilitySummary';

/**
 * 
 * @export
 * @interface HchbFacilityPage
 */
export interface HchbFacilityPage {
    /**
     * 
     * @type {Array<HchbFacilitySummary>}
     * @memberof HchbFacilityPage
     */
    data: Array<HchbFacilitySummary>;
    /**
     * 
     * @type {number}
     * @memberof HchbFacilityPage
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof HchbFacilityPage
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof HchbFacilityPage
     */
    total: number;
    /**
     * 
     * @type {boolean}
     * @memberof HchbFacilityPage
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the HchbFacilityPage interface.
 */
export function instanceOfHchbFacilityPage(value: object): value is HchbFacilityPage {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function HchbFacilityPageFromJSON(json: any): HchbFacilityPage {
    return HchbFacilityPageFromJSONTyped(json, false);
}

export function HchbFacilityPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbFacilityPage {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbFacilitySummaryFromJSON)),
        'page': json['page'],
        'limit': json['limit'],
        'total': json['total'],
        'has_next': json['has_next'],
    };
}

export function HchbFacilityPageToJSON(json: any): HchbFacilityPage {
    return HchbFacilityPageToJSONTyped(json, false);
}

export function HchbFacilityPageToJSONTyped(value?: HchbFacilityPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(HchbFacilitySummaryToJSON)),
        'page': value['page'],
        'limit': value['limit'],
        'total': value['total'],
        'has_next': value['has_next'],
    };
}

